import { TextField } from '@mui/material'
import { useEffect, useState } from 'react'

const DEBOUNCE_DELAY_MS = 300

interface NameFilterProps {
    name: string
    onChange: (name: string) => void
}

export function NameFilter({ name, onChange }: NameFilterProps) {
    const [localValue, setLocalValue] = useState(name)

    useEffect(() => {
        if (localValue === name) {
            return
        }
        const timeoutId = setTimeout(() => {
            onChange(localValue)
        }, DEBOUNCE_DELAY_MS)
        return () => clearTimeout(timeoutId)
    }, [localValue, onChange, name])

    useEffect(() => {
        setLocalValue(name)
    }, [name])

    const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setLocalValue(event.target.value)
    }

    return (
        <TextField
            label="Name"
            placeholder="Search by name..."
            value={localValue}
            onChange={handleNameChange}
            fullWidth
        />
    )
}
